/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { createContext } from 'react';
import PropTypes from "prop-types";
var I18nContext = /*#__PURE__*/createContext({});
var OuiI18nProvider = I18nContext.Provider,
  OuiI18nConsumer = I18nContext.Consumer;
var OuiContext = ({
  i18n = {},
  children
}) => <OuiI18nProvider value={i18n}>{children}</OuiI18nProvider>;
OuiContext.propTypes = {
  i18n: PropTypes.shape({
    mapping: PropTypes.shape({}),
    mappingFunc: PropTypes.func,
    formatNumber: PropTypes.func,
    formatDateTime: PropTypes.func,
    locale: PropTypes.string
  }).isRequired,
  /**
     * ReactNode to render as this component's content
     */
  children: PropTypes.node.isRequired
};
export { OuiContext, OuiI18nConsumer, I18nContext };
try {
  OuiContext.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src3672379046/src/src/components/context/context.tsx',
    description: '',
    displayName: 'OuiContext',
    methods: [],
    props: {
      i18n: {
        defaultValue: {
          value: '{}'
        },
        description: '',
        name: 'i18n',
        parent: {
          fileName: 'src/src/components/context/context.tsx',
          name: 'OuiContextProps'
        },
        declarations: [{
          fileName: 'src/src/components/context/context.tsx',
          name: 'OuiContextProps'
        }],
        required: false,
        type: {
          name: 'I18nShape'
        }
      },
      children: {
        defaultValue: null,
        description: "ReactNode to render as this component's content",
        name: 'children',
        parent: {
          fileName: 'src/src/components/context/context.tsx',
          name: 'OuiContextProps'
        },
        declarations: [{
          fileName: 'src/src/components/context/context.tsx',
          name: 'OuiContextProps'
        }, {
          fileName: 'src/node_modules/@types/react/index.d.ts',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'ReactNode'
        }
      }
    },
    extendedInterfaces: ['OuiContextProps']
  };
} catch (e) {}